<template>
  <div class="ws-modal full">
    <div class="ws-modal__form edit">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">{{$t('История назначения Главных экспертов')}}</h2>
      </header>
      <div class="ws-modal__content">
        <WsExamLog
            :examLogs="examLogs"
            :examPagination="examPagination"
            :isExamPending="isExamPending"
            :users="users"
            @pageChange='onExamPageChange'
        />
        <b-loading :is-full-page="false" :active="isExamPending"></b-loading>
      </div>
    </div>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click="close">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import WsExamLog from '../WsExamLog.vue'
import {
  LOGS_ACTION_CATEGORIES,
  isValidGuid
} from '@/components/de/demo-exams/data/log-data.js'

export default {
  name: 'WsExamExpertLog',
  components: { WsExamLog },
  props: {
    examGuid: String
  },
  data () {
    return {
      isExamPending: false,
      page: 1,
      per_page: 10,
      examPagination: {},
      examLogs: [],
      users: []
    }
  },
  created () {
    this.fetchExamLogs()
  },
  methods: {
    ...mapActions('esatk/users-list', { findUsers: 'find' }),
    ...mapActions('event-log', ['getMainExpertLogs']),
    isValidGuid,
    async fetchUsers () {
      const authors = []
      let actions = []
      this.examLogs.forEach(user => {
        if (!authors.includes(user.author)) {
          authors.push(user.author)
        }
        if (user.category === LOGS_ACTION_CATEGORIES.EXPERTS) {
          if (user.new_value && this.isValidGuid(user.new_value)) {
            if (!authors.includes(user.new_value)) {
              authors.push(user.new_value)
            }
          }
          if (user.old_value && this.isValidGuid(user.old_value)) {
            if (!authors.includes(user.old_value)) {
              authors.push(user.old_value)
            }
          }
        }
      })
      if (authors.length) actions = [this.findUsers({ guid: authors }), ...actions]
      if (actions.length) {
        const [users] = await Promise.all(actions)
        this.users = users || []
      }
    },
    close () {
      this.$parent.close()
    },
    onExamPageChange (pagination) {
      this.page = pagination.page + 1
      this.per_page = pagination.per_page
      this.fetchExamLogs()
    },
    async fetchExamLogs () {
      this.isExamPending = true
      const res = await this.getMainExpertLogs({
        params: { examGuid: this.examGuid },
        query: `page=${this.page}&per_page=${this.per_page}`
      })
      this.examPagination = res.meta
      this.examLogs = res.data || []
      await this.fetchUsers()

      this.isExamPending = false
    }
  }
}
</script>

<style scoped>
.ws-modal__form.edit {
    padding: 40px 28px;
}
.ws-modal.full {
    max-width: 100%;
    min-width: 1026px;
}
</style>
